import React from 'react';
import { ChakraProvider, Flex, Box, Heading, Icon } from '@chakra-ui/react';
import { FiShield } from 'react-icons/fi';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { PRIVACY_POLICY_URL, PDF_WORKER_URL, enTheme } from './shared';
function PrivacyPage() {
    return (React.createElement(ChakraProvider, { theme: enTheme },
        React.createElement(Flex, { direction: "column", h: "100vh" },
            React.createElement(Flex, { align: "center", gap: 3, px: { base: 5, md: 8 }, py: 4, bg: "rgba(10, 10, 10, 0.92)", borderBottom: "1px solid", borderColor: "rgba(225, 140, 106, 0.25)" },
                React.createElement(Icon, { as: FiShield, color: "#e18c6a", boxSize: 6 }),
                React.createElement(Heading, { size: "md", color: "white" }, "Privacy Policy")),
            React.createElement(Box, { flex: "1", minH: 0, bg: "gray.100" },
                React.createElement(Worker, { workerUrl: PDF_WORKER_URL },
                    React.createElement(Viewer, { fileUrl: PRIVACY_POLICY_URL }))))));
}
export default PrivacyPage;
